document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.querySelector('.toggle-button');
  const additionalContent = document.querySelector('.additional-content-long');

  if (toggleButton) {
    toggleButton.addEventListener('click', function() {
      if (additionalContent.style.display === 'none' || additionalContent.style.display === '') {
        additionalContent.style.display = 'block';
        toggleButton.textContent = 'Learn More -';
      } else {
        additionalContent.style.display = 'none';
        toggleButton.textContent = 'Learn More +';
      }
    });
  }
});